import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CourseDetailService {
  private _course = new BehaviorSubject<any>(null);
  course$ = this._course.asObservable();

  open(video: any, isWebinar = false) {
    if (video) { video.__isWebinar = isWebinar; }
    this._course.next(video);
  }

  close() {
    this._course.next(null);
  }
}
